import { Injectable } from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {ockUser} from "../interface/ockUser";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {first, take} from "rxjs/operators";
import {ockPolicy} from "../interface/ockPolicy";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class OckPolicyService {
  private readonly listSubject: ReplaySubject<CountedAndPaginated<ockPolicy>>
    = new ReplaySubject<CountedAndPaginated<ockPolicy>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService
  ) { }

  public getListSubject(): ReplaySubject<CountedAndPaginated<ockPolicy>> {
    return this.listSubject;
  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/ock/policy?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<ockPolicy>) => {
        this.listSubject.next(result);
      });
  }

  public downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/ock/policy/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
}
